import type { JsonData } from '../types';
import { isArrayOfIdCaption } from '../utils';
import type { VisibilityCondition } from './visibility-condition.interfaces';
import { VisibilityConditionBase } from './visibility-condition-base';

export class GroupVisibilityCondition extends VisibilityConditionBase {
  constructor(fieldCondition: VisibilityCondition) {
    super(fieldCondition);
  }

  public runVisibilityCondition(currentData: JsonData): boolean {
    let isHidden = this.defaultIsHidden;

    // Handles super user role
    if (
      Array.isArray(currentData) &&
      currentData.length > 0 &&
      currentData[0].id === -1
    ) {
      isHidden = false;
    } else if (isArrayOfIdCaption(currentData)) {
      // for groups a user is either part or not part of a group
      if (this.fieldCondition.negation === false) {
        isHidden = !currentData.some(
          (group) => group.id === this.fieldCondition.targetValueId,
        );
      } else if (this.fieldCondition.negation === true) {
        isHidden = currentData.some(
          (group) => group.id === this.fieldCondition.targetValueId,
        );
      }
    }

    return isHidden;
  }
}
